import React from "react";
import { useSearchParams } from "react-router-dom";

import { Tabs, Text } from "@performyard/py-components";

import PageTitle from "../../../../../components/PageTitle";

import CurrentPulseTab from "./tabs/CurrentPulse";
import QuestionsTab from "./tabs/Questions";
import SettingsTab from "./tabs/Settings";

const PulseSurveySettings = () => {
	const [searchParams] = useSearchParams();
	const activeTab = searchParams.get("tab") || "settings";

	return (
		<div className="relative w-full" id="pulse-survey-settings">
			<PageTitle title="Pulse Survey Settings" />
			<div className="mb-10">
				<Text size="heading-5" weight="semi-bold" color="neutral-9">
					Pulse Survey Settings
				</Text>
			</div>
			<Tabs
				urlParam="tab"
				size="large"
				value={activeTab}
				tabs={[
					{
						value: "settings",
						label: "Settings",
						content: <SettingsTab />,
					},
					{
						value: "questions",
						label: "Questions",
						content: <QuestionsTab />,
					},
					{
						value: "current-pulse",
						label: "Current Pulse",
						content: <CurrentPulseTab />,
					},
				]}
			/>
		</div>
	);
};

export default PulseSurveySettings;
